"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var formik_1 = require("formik");
var react_1 = __importStar(require("react"));
var context_1 = require("../../../../context");
var utils_1 = require("../../../../utils");
var Card_1 = require("../../../Card");
var Tabs_1 = require("../../../Tabs/Tabs");
var Fields_1 = require("../Fields");
exports.errorKeys = [
    'warm_home_advice',
    'warm_home_advice_other',
    'warm_home_action',
    'warm_home_action_other',
    'psr_advice',
    'psr_advice_other',
    'psr_action',
];
var WarmHomeForm = function (_a) {
    var tabId = _a.tabId;
    var _b, _c;
    var trans = context_1.useSemantics().trans;
    var setTabError = Tabs_1.useTabsContext().setTabError;
    var errors = formik_1.useFormikContext().errors;
    var _d = react_1.useState(((_b = errors.project) === null || _b === void 0 ? void 0 : _b.warm_home) || {}), formErrors = _d[0], setFormErrors = _d[1];
    react_1.useEffect(function () { return setTabError(tabId, utils_1.objectHasAnyKey(formErrors, exports.errorKeys)); }, [formErrors]);
    react_1.useEffect(function () { var _a; return setFormErrors(((_a = errors.project) === null || _a === void 0 ? void 0 : _a.warm_home) || {}); }, [(_c = errors.project) === null || _c === void 0 ? void 0 : _c.warm_home]);
    return (react_1.default.createElement(Card_1.Card, { heading: trans('project:slhh::headings.warm-home-discounts'), subHeading: trans('project:slhh::headings.slhh') },
        react_1.default.createElement(Fields_1.WarmHomeAdviceInput, null),
        react_1.default.createElement(Fields_1.WarmHomeActionInput, null),
        react_1.default.createElement(Fields_1.PsrAdviceInput, null),
        react_1.default.createElement(Fields_1.PsrActionInput, null)));
};
exports.default = WarmHomeForm;
//# sourceMappingURL=WarmHomeForm.js.map